import React from 'react';
import SideBarContainer from './SideBar/SideBarContainer.js';
import ViewerButtons from './ViewerButtons.js';
import PopupContainer from './PopupContainer.js';
import InfoBox from './InfoBox.js';
import NotificationsContainer from '../InventumViewer/Components/NotificationsContainer.js';
import withRouter from '../../withRouter.js';

class SiteControls extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <SideBarContainer />
        <ViewerButtons />
        <PopupContainer />
        <InfoBox />
        <NotificationsContainer />
        {this.props.children}
      </div>
    )
  }
}

let SiteControlsContainer = withRouter(SiteControls);

export default SiteControlsContainer;
